import http from './config'

// post 请求
export const POST = (url, data = {}) => {
  return http.post(url, data)
}

// get 请求
export const GET = (url, data = {}) => {
  return http.get(url, {
    params: data
  })
}
// get 请求
export const DOWNLOAD = (url, data = {}) => {
  return http.get(url, {
    params: data,
    responseType: 'blob'
  })
}

// 上传游戏图片
export const uploadImg = (data) => {
  return POST('/upload/img', data)
}

// 上传视频
export const uploadVideo = (data) => {
  return POST('/upload/video', data)
}

// 获取游戏图片
export const fileInfo = (data) => {
  return GET('/file/info', data)
}

// 获取所有游戏
export const games = (data) => {
  return GET('/games', data)
}

// 获取游戏图片
export const downLoadFile = (data) => {
  return DOWNLOAD('/file/download', data)
}



// WEBPACK FOOTER //
// ./src/api/index.js